/**
 * author: 胡枭
 * 描述：竞价接口
 */

import request from '@/utils/request.js'

const baseUrl = process.env.VUE_APP_PURCHASE_API
// const baseUrl = ''

// 获取竞价大厅的身份token
export function getCompeteHallTokenApi(params, orderId) {
  return request({
    url: `${baseUrl}/workbench/competition-hall/${orderId}/token`,
    method: 'get',
    params
  })
}

// 查询供应商在线列表 (竞价大厅）
export function getPurchaseOnlineListApi(orderId, token, needLoading) {
  return request(
    {
      url: `${baseUrl}/workbench/competition-hall/${orderId}/${token}/online`,
      method: 'get'
    },
    needLoading
  )
}

// 查询竞价单信息 （竞价大厅）
export function getCompeteHallOrdersApi(orderId, token, needLoading) {
  return request(
    {
      url: `${baseUrl}/workbench/competition-hall/${orderId}/${token}/detail`,
      method: 'get'
    },
    needLoading
  )
}

// 用户提交报价
export function quoteApi(data, orderId, token, needLoading) {
  return request(
    {
      url: `${baseUrl}/workbench/competition-hall/${orderId}/${token}/offer`,
      method: 'post',
      data
    },
    needLoading
  )
}

// 竞价大厅竞价历史
export function getCompeteHistoryListApi(params, orderId, token) {
  return request({
    url: `${baseUrl}/workbench/competition-hall/${orderId}/${token}/rank-pages`,
    method: 'get',
    params
  })
}

// 查询聊天消息列表
export function getChatMesApi(orderId, token) {
  return request({
    url: `${baseUrl}/workbench/competition-hall/${orderId}/${token}/chats`,
    method: 'get'
  }, false)
}
